/* tslint:disable */
/* eslint-disable */
/**
 * ProjectOne Swagger
 * API for Classical Conversations content and communities.  # Service URLs In local dev: - [The **local backend**](http://0.0.0.0:8080/) defaults to running on port 8080. - [The **local frontend**](http://0.0.0.0:3000/) defaults to running on port 3000.  In the DEV environment: - [The **DEV backend**](https://dev-ccp1-api.classicaltesting.net/) runs at https://dev-ccp1-api.classicaltesting.net/. - [The **DEV frontend**](https://dev-ccp1.classicaltesting.net/) runs at https://dev-ccp1.classicaltesting.net/.  The TEST environment is similar, but with `test-` instead of `dev-`.
 *
 * The version of the OpenAPI document: 4bcfc99b (Thu Mar  7 14:01:07 UTC 2024)
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime'
import { CashAmount, CashAmountFromJSON, CashAmountToJSON } from './'

/**
 *
 * @export
 * @interface UpdateTuitionPaymentRequestBody
 */
export interface UpdateTuitionPaymentRequestBody {
  /**
   * The unique identifier for the student the tuition payment if for
   * @type {number}
   * @memberof UpdateTuitionPaymentRequestBody
   */
  studentKey?: number
  /**
   * The unique identifier for the program the tuition payment if for
   * @type {number}
   * @memberof UpdateTuitionPaymentRequestBody
   */
  programKey?: number
  /**
   *
   * @type {CashAmount}
   * @memberof UpdateTuitionPaymentRequestBody
   */
  amount?: CashAmount
  /**
   * Date the user received the payment from the parent for the program
   * @type {Date}
   * @memberof UpdateTuitionPaymentRequestBody
   */
  dateReceived?: Date
  /**
   * Description that goes along with the tuition payment
   * @type {string}
   * @memberof UpdateTuitionPaymentRequestBody
   */
  description?: string
}

export function UpdateTuitionPaymentRequestBodyFromJSON(
  json: any
): UpdateTuitionPaymentRequestBody {
  return UpdateTuitionPaymentRequestBodyFromJSONTyped(json, false)
}

export function UpdateTuitionPaymentRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UpdateTuitionPaymentRequestBody {
  if (json === undefined || json === null) {
    return json
  }
  return {
    studentKey: !exists(json, 'studentKey') ? undefined : json['studentKey'],
    programKey: !exists(json, 'programKey') ? undefined : json['programKey'],
    amount: !exists(json, 'amount')
      ? undefined
      : CashAmountFromJSON(json['amount']),
    dateReceived: !exists(json, 'dateReceived')
      ? undefined
      : new Date(json['dateReceived']),
    description: !exists(json, 'description') ? undefined : json['description'],
  }
}

export function UpdateTuitionPaymentRequestBodyToJSON(
  value?: UpdateTuitionPaymentRequestBody | null
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    studentKey: value.studentKey,
    programKey: value.programKey,
    amount: CashAmountToJSON(value.amount),
    dateReceived:
      value.dateReceived === undefined
        ? undefined
        : value.dateReceived.toISOString(),
    description: value.description,
  }
}
